import React, { useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import AOS from "aos";
import "aos/dist/aos.css";
import HomePage from './pages/HomePage';
import Program from './pages/Program';
import Galeri from './pages/Galeri';
import Donasi from './pages/Donasi';
import Daftar from './pages/Daftar';
import Dev from './pages/Dev';

const App = () => {
  useEffect(() => {
    AOS.init({
      easing: "ease-in-out",
    });
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/Program" element={<Program />} />
        <Route path="/Galeri" element={<Galeri />}/>
        <Route path="/Donasi" element={<Donasi />} />
        <Route path="/Daftar" element={<Daftar />} />
        <Route path="/Dev" element={<Dev />} />
      </Routes>
    </Router>
  );
};

export default App;
